import { render, staticRenderFns } from "./HistoricalPurchasesPopup.vue?vue&type=template&id=5889d71c"
import script from "./HistoricalPurchasesPopup.vue?vue&type=script&lang=js"
export * from "./HistoricalPurchasesPopup.vue?vue&type=script&lang=js"
import style0 from "./HistoricalPurchasesPopup.vue?vue&type=style&index=0&id=5889d71c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports